import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const searchContainer = style({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  padding: '8px 12px',
  borderRadius: vars.buttons.radius,
  top: 0,
  background: vars.color.white,
  marginBottom: 7,
  zIndex: 1
})

export const addressSearchInput = style({
  flex: 1,
  border: 'none',
  outline: 'none',
  fontSize: vars.font.body.size,
  fontWeight: vars.font.body.weight,
  color: vars.color.dark,
  '::placeholder': {
    color: vars.color.medium
  },

  selectors: {
    // Override v2 legacy style
    '&:is([type=text])': {
      height: 'auto',
      margin: 0,
      padding: 0,
      float: 'none',
      border: 'none',
      width: '100%',
      fontSize: vars.font.body.size,
      fontWeight: vars.font.body.weight
    }
  }
})

export const noResultsMessage = style({
  color: vars.color.dark,
  fontSize: vars.font.body.size,
  fontWeight: vars.font.body.weight,
  display: 'flex',
  alignItems: 'center',
  padding: '10px 0',
  gap: 10
})

export const addressRoot = style({
  position: 'relative',
  width: '100%'
})

export const autocompleteRow = style({
  display: 'flex',
  alignItems: 'stretch',
  gap: 0,
  width: '100%'
})

export const autocompleteField = style({
  flex: 1,
  minWidth: 0
})

export const valueBoxWithActions = style({
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0
})

export const actionButton = style({
  display: 'none',
  boxSizing: 'border-box',
  height: 'auto',
  minHeight: 48,
  width: 42,
  alignItems: 'center',
  justifyContent: 'center',
  background: vars.color.light,
  color: vars.color.darkLighter,
  border: `1px solid ${vars.color.mainHover}`,
  borderLeft: 'none',
  cursor: 'pointer',
  fontSize: 14,
  textDecoration: 'none',
  padding: 0,
  selectors: {
    '&:hover': {
      color: vars.color.dark
    },
    '&:last-child': {
      borderRadius: `0 ${vars.buttons.radius} ${vars.buttons.radius} 0`
    }
  }
})

export const actionButtonVisible = style({
  display: 'flex'
})

export const actionButtonAlways = style({
  display: 'flex',
  borderRadius: `0 ${vars.buttons.radius} ${vars.buttons.radius} 0`,
  borderLeft: 'none'
})

export const localityRow = style({
  display: 'flex',
  gap: 10,
  flexWrap: 'wrap'
})

export const localityField = style({
  flex: 1,
  minWidth: 120
})

export const localityFieldNarrow = style({
  flex: '0 0 125px',
  minWidth: 100
})

export const complementToggle = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  color: vars.color.darkLighter,
  fontWeight: 600,
  fontSize: vars.font.body.size,
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: 0,
  selectors: {
    '&:hover': {
      color: vars.color.primary
    }
  }
})

export const mapContainer = style({
  display: 'none',
  height: 300,
  position: 'absolute',
  right: 0,
  left: 0,
  zIndex: 2,
  border: `1px solid ${vars.font.input.borderColor}`,
  borderTop: 'none',
  background: vars.color.white
})

export const mapContainerOpen = style({
  display: 'block'
})
